import CallIntakeForm from "./CallIntakeForm";

export function CallsPage() {
  return <CallIntakeForm />;
}
